import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { LANGUAGES, getLanguageFlag } from './languages';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage = LANGUAGES.find(lang => lang.lng === i18n.language) || LANGUAGES[0];

  const handleLanguageChange = (lng: string) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        size="sm"
        className="flex items-center gap-2 rounded-full"
        onClick={() => setIsOpen(!isOpen)}
      >
        <img
          src={getLanguageFlag(currentLanguage.lng)}
          alt={currentLanguage.name}
          className="w-4 h-4 rounded-sm"
        />
        <span className="hidden sm:inline">{currentLanguage.name}</span>
        {isOpen ? (
          <ChevronUp className="h-4 w-4" />
        ) : (
          <ChevronDown className="h-4 w-4" />
        )}
      </Button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-[#111827] rounded-md shadow-lg py-1 z-50">
          {LANGUAGES.map((language) => (
            <div
              key={language.lng}
              className={`px-4 py-2 text-sm cursor-pointer flex items-center gap-2 ${
                i18n.language === language.lng ? 'text-[#07BEFA]' : 'text-[#F8FAFC]'
              } hover:bg-[#1A2234]`}
              onClick={() => handleLanguageChange(language.lng)}
            >
              <img
                src={getLanguageFlag(language.lng)}
                alt={language.name}
                className="w-4 h-4 rounded-sm"
              />
              <span>{language.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
} 